(() => {
  if (customElements.get('tmg-material-modal')) return;
  const ModalDialog = customElements.get('modal-dialog');
  if (!ModalDialog) return;

  const DURATION = 250;

  // Builds on the theme's <modal-dialog>: it already handles Escape, backdrop click,
  // the ModalClose- button, focus trap/return and the body scroll lock.
  customElements.define(
    'tmg-material-modal',
    class TmgMaterialModal extends ModalDialog {
      connectedCallback() {
        super.connectedCallback();
        this.markHeadings();
      }

      // A paragraph that is entirely bold is a section heading (richtext has no headings).
      markHeadings() {
        this.querySelectorAll('.tmg-material-modal__content p').forEach((paragraph) => {
          const strong = paragraph.firstElementChild;
          const isHeading =
            paragraph.children.length === 1 &&
            strong?.tagName === 'STRONG' &&
            paragraph.textContent.trim() === strong.textContent.trim() &&
            paragraph.textContent.trim() !== '';
          paragraph.classList.toggle('tmg-material-modal__subheading', isHeading);
        });
      }

      show(opener) {
        clearTimeout(this.closeTimer);
        this.classList.remove('is-closing');
        super.show(opener);
        opener?.setAttribute('aria-expanded', 'true');
        this.querySelector('.tmg-material-modal__close')?.focus();
      }

      hide() {
        if (!this.hasAttribute('open') || this.classList.contains('is-closing')) return;
        this.openedBy?.setAttribute('aria-expanded', 'false');
        // Play the reverse animation, then let <modal-dialog> close and restore focus.
        this.classList.add('is-closing');
        this.closeTimer = setTimeout(() => {
          this.classList.remove('is-closing');
          super.hide();
        }, DURATION);
      }
    }
  );
})();
